const footer = "_uxsf6ahyyy";
const navigationButtons = "_uxsnveahqi";

export { footer, navigationButtons };
import "./integration.bottom-navigation.style.linaria.module.css";
//# sourceMappingURL=integration.bottom-navigation.style.js.map
